import { render, staticRenderFns } from "./item-lots.vue?vue&type=template&id=fc3a46f4&scoped=true"
import script from "./item-lots.vue?vue&type=script&lang=js"
export * from "./item-lots.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc3a46f4",
  null
  
)

export default component.exports